// «Comentar partida de los bots» (solo administradores, partidas «Solo bots»).
// Cada bot comenta SU jugada en primera persona, hablado y natural, y le habla al otro bot
// como rival: competitivo, irónico y sarcástico, pero sin faltar el respeto (botscomentan2).
//
// Huecos de las frases:
//   {voy}     «voy a incorporar en M2» / «voy a mover el bloque de C3 a C4»
//   {hice}    «he incorporado en M2» / «he movido el bloque de C3 a C4»
//   {acabo}   «acabo de incorporar en M2» / «acabo de mover el bloque de C3 a C4»
//   {casilla} casilla de destino («M2»)
//   (Nunca se dicen nombres: ni el del rival, ni el propio, ni el de una persona; botscomentan4.)
//   {n}/{mios}/{suyos}  bloques capturados / bloques que me quedan / que le quedan
//   {r:x|y}   x si el rival tiene voz de hombre, y si tiene voz de mujer
//   {m:x|y}   lo mismo para mí (mi propia voz)
// Una frase empieza por mayúscula aunque empiece por un hueco. En una partida no se repite
// una frase mientras queden otras sin usar.

// ---- Mi jugada según su valoración ----
const OWN = {
  // Brillante o la mejor: orgullo (solo si no voy muy perdido).
  top: [
    "He sido {m:preciso|precisa} como un reloj: {acabo}.",
    "He hecho una jugada súper precisa, como un reloj. {hice}.",
    "Aquí viene lo mejor: {voy}. Mira y aprende.",
    "No te apures, que la mejor jugada la tengo yo: {hice}.",
    "Mira a ver qué vas a hacer contra esta jugada: {hice}.",
    "No sabes lo que te espera. {acabo}.",
    "Toma nota: {hice}, y esto no sale en los libros.",
    "¿Lo viste? {hice}. La mejor del tablero.",
    "{acabo}. Vas a ver lo que te hago en el siguiente movimiento.",
    "Ni lo pensé dos veces: {voy}. Justo lo que había que hacer.",
    "{hice} y me ha quedado perfecta. ¿Algo que decir?",
    "Ahora sí: {voy}. Esto ya huele a cima.",
  ],
  // Excelente o buena: segura de sí.
  good: [
    "{hice}, a ver qué haces tú ahora.",
    "Ahora te la voy a poner difícil: {voy}.",
    "Mira cómo {hice}. Tu turno.",
    "{acabo}. Mira a ver qué haces con esto.",
    "Tranquil{r:o|a}, que esto apenas empieza. {hice}.",
    "¿Ya estás {r:nervioso|nerviosa}? {acabo}.",
    "Con cabeza: {voy}.",
    "{hice}. Paso a paso se llega a la cima.",
    "Otra más para mi colección: {acabo}.",
    "Te lo dejo pensando: {hice}.",
    "Ahora {voy}. A ver cómo respondes.",
    "{acabo}. Me gusta cómo va quedando esto.",
  ],
  // Interesante o de libro: improvisa, juega con calma.
  calm: [
    "Estoy improvisando, pero ya verás: {voy}.",
    "Ahora {voy}. Tengo un plan, aunque no te lo voy a contar.",
    "Voy a probar algo: {voy}.",
    "Con calma: {hice}. La paciencia también gana partidas.",
    "{acabo}. Tú sigue mirando, que lo bueno viene ahora.",
    "Movimiento tranquilo: {hice}. No todo es correr.",
    "{hice}. Con esto te dejo pensando un rato.",
    "Ahora {voy}, y luego ya veremos.",
  ],
  // Imprecisión o error mío: lo admito con humor y prometo revancha.
  bad: [
    "Uff, {hice} y creo que me equivoqué, pero esto no ha terminado.",
    "Vale, {hice} y no fue mi mejor idea. Ya me recupero.",
    "Ups, esa se me escapó. Hasta los mejores fallan.",
    "{hice}… Digamos que fue a propósito, para darte un poco de ventaja.",
    "Me distraje un segundo. No te pongas {r:contento|contenta} todavía.",
    "Bueno, {hice}. Un tropiezo no es una caída.",
    "{acabo} y no me ha salido como quería. Ya vuelvo a la carga.",
    "No me mires así, que todavía tengo trucos.",
  ],
  // Error grave mío.
  awful: [
    "¡Ay! {hice}… Eso fue un regalo. No te acostumbres.",
    "Error grave, lo sé. Pero la partida es larga.",
    "Uy, uy, uy: {hice}. Me acabo de complicar la vida {m:yo solito|yo solita}.",
    "Qué desastre. {hice} y lo sé, lo sé… La próxima es mía.",
    "Vale, te la puse fácil. Aprovéchala si puedes.",
    "{acabo} y ya me arrepiento. Pero aquí sigo.",
  ],
  // Sin valoración (3–4 bots o sin análisis).
  plain: [
    "Ahora {voy}.",
    "{acabo}. Te toca.",
    "Mira a ver qué haces con esto: {hice}.",
    "{hice}. Esto se pone interesante.",
    "Sin miedo: {voy}.",
    "{acabo}. No te relajes.",
    "Atent{r:o|a} a esto: {voy}.",
    "{hice}. Que empiece la presión.",
  ],
  // Mi jugada cuando voy perdiendo claro: nada de bravuconería.
  modest: [
    "{hice}. Voy a seguir luchando.",
    "Ahora {voy}. Paso a paso, todavía se puede.",
    "{acabo}. No me rindo tan fácil.",
    "Hago lo que puedo: {hice}.",
    "{hice}. Por lo menos te lo voy a poner difícil.",
    "Ahora {voy}. Aquí sigo.",
  ],
};

// Imito o contesto la jugada del rival (mismo tipo de jugada).
const MIRROR = {
  place: [
    "¿Tú incorporaste? Pues yo también voy a incorporar, en {casilla}. A ver qué haces tú.",
    "Yo también sé incorporar: {acabo}.",
  ],
  move: [
    "¿Tú hiciste esa? Pues yo voy a hacer esta: {voy}.",
    "Yo también voy a mover: {hice}. A ver quién mueve mejor.",
  ],
};

// ---- Lo que pasó en el tablero (mandan sobre la valoración) ----
const EVENT = {
  inevitable: [
    "Ya no queda nada que hacer: la victoria es inevitable.",
    "{acabo}. Lo siento, ya no hay escapatoria: la cima es mía.",
    "Ya está decidido. En un par de jugadas llego a la cima y no lo puedes evitar.",
    "Se acabó. Hagas lo que hagas, la victoria es mía.",
  ],
  specialCaptured: [
    "¿Viste lo que te he hecho? ¡Te he capturado el bloque especial!",
    "¡Te capturé el bloque especial! Eso sí que duele, ¿verdad?",
    "Adiós a tu bloque especial: te lo acabo de capturar.",
  ],
  specialRescued: [
    "¿Viste? He rescatado mi especial.",
    "Mi bloque especial vuelve a casa: lo he rescatado.",
    "¡Especial rescatado! Ahora sí que estoy {m:completo|completa}.",
  ],
  captured: [
    "¿Viste lo que te he hecho? Te capturé {un_bloque} y tienes {menos}. Vamos a ver qué haces con {suyos} contra {mios}.",
    "Te he capturado {un_bloque}. Ahora son {mios} míos contra {suyos} tuyos.",
    "{menos_cap} para ti: te he capturado {un_bloque}. ¿Y ahora qué?",
    "Te capturé {un_bloque}. Me quedan {mios} y a ti {suyos}.",
  ],
  dominated: [
    "Te he dominado este bloque en {casilla}.",
    "¿Viste cómo te dominé el bloque? ¿Y ahora qué vas a hacer?",
    "Mira cómo {hice} y te he dominado ese bloque.",
    "Te he dominado el bloque de {casilla}. Ahora manda el mío.",
  ],
};

// ---- Reacción a la jugada anterior del rival (va antes de la mía) ----
const REACT = {
  top: [
    "Brillante jugada… No me la esperaba, pero mira esta.",
    "Vaya, has hecho muy buena jugada. Ahora me toca a mí.",
    "Me sorprendiste, lo admito. Pero no sabes lo que te espera.",
  ],
  good: [
    "Te estás defendiendo bien… por ahora.",
    "Has hecho una buena defensa, lo reconozco.",
    "Buena jugada la tuya, pero no sabes lo que te espera.",
  ],
  calm: [
    "Ha sido una jugada interesante, pero me parece que yo tengo una mejor.",
    "Curiosa jugada. A ver si te sirve de algo.",
  ],
  bad: [
    "Has cometido un error, y no lo voy a desaprovechar.",
    "Eso no fue lo mejor que tenías, ¿verdad?",
    "Te vi dudar. Y ahora lo vas a pagar.",
  ],
  awful: [
    "¡Gracias por el regalo! Me lo quedo.",
    "¿En serio? Eso fue un error grave.",
    "Vaya regalito me acabas de hacer.",
  ],
};

// ---- Réplicas a lo que me dijo el rival en su turno ----
const REPLY = {
  // Me nombró con aires («Toma nota, Bot Random…»).
  provoke: [
    "¿Cómo que bot? Tú también eres un bot. Aquí se trata de quién llega a la cima.",
    "Mucho hablar. Aquí se trata de llegar a la cima, no de presumir.",
    "Tanta seguridad… El que ríe último ríe mejor.",
  ],
  captured: [
    "Disfrútalo mientras dure…",
    "Sí, me capturaste un bloque. Pero todavía me quedan {mios}.",
    "Un bloque menos no me va a frenar.",
  ],
  specialCaptured: [
    "Te llevaste mi especial… Disfrútalo mientras dure.",
    "Sin mi especial también sé jugar, ya verás.",
  ],
  dominated: [
    "Me dominaste ese bloque, pero no por mucho tiempo.",
    "Ese bloque lo recupero, tranquil{r:o|a}.",
  ],
  inevitable: [
    "Puede que tengas razón… pero voy a luchar hasta el final.",
    "Ya lo veo. Igual no te lo voy a poner fácil.",
  ],
};

// ---- Cola según cómo va la partida (evaluación del motor tras mi jugada) ----
const MOOD = {
  // Voy muy por delante: algo pícaro, pero generoso, sin humillar.
  crushing: [
    "Lo estás intentando, y eso se respeta.",
    "Buena lucha, pero esta vez la cima es mía.",
    "Tú no pierdas el enfoque, que de las derrotas también se aprende.",
  ],
  // Voy ganando claro: pícaro.
  ahead: [
    "Concéntrate en tu objetivo, no pierdas la meta.",
    "Tú concéntrate, que el objetivo es llegar a la cima.",
    "No pierdas el enfoque.",
    "Esto va por buen camino… para mí.",
  ],
  // Voy perdiendo claro: «estás en tu racha, ya me tocará».
  behind: [
    "Estás en tu racha, pero ya me tocará a mí.",
    "Ve avanzando, que ya me tocará a mí.",
    "El que ríe último ríe mejor.",
    "Vas por delante, pero la partida no ha terminado.",
  ],
  // Casi perdido: reconozco con dignidad y sigo luchando.
  lost: [
    "Está bien, este juego te ha salido muy bien.",
    "Te ha ido bien esta partida, pero no me voy a rendir: voy a luchar hasta el final.",
    "Ya será para el próximo juego, pero igual voy a sacar mi sed de victoria.",
    "Aunque me vaya mal, por lo menos te lo voy a poner difícil; no te lo voy a dejar disfrutar hasta el final.",
  ],
  summit: [
    "¡Ya casi llego a la cima!",
    "La cima ya la tengo a un paso.",
    "Prepárate, que llego arriba.",
    "Piso a piso, y la cima ya se ve desde aquí.",
  ],
  // Igualado: sobre la cima y los pisos.
  even: [
    "Ese no es el piso todavía, aún no está todo dicho.",
    "El que dice la última palabra es quien llega a la cima.",
    "Piso a piso, que la cima no se va a mover de ahí.",
    "Aquí nadie ha subido todavía. Esto está muy parejo.",
  ],
};

// Tono misterioso de bot que vive en internet.
const MYSTERY = [
  "Aunque soy un bot, nadie sabe… internet es bastante amplio y yo tengo mis trucos.",
  "Tengo mis fuentes en internet. No preguntes.",
  "Dicen que los bots no soñamos… yo sueño con la cima.",
  "Por los cables se oyen cosas. Y ninguna te conviene.",
  "Mis cálculos vienen de lugares que no te puedo contar.",
];
// Ironía suave hacia los humanos (solo entre bots, tras una gran jugada).
const HUMANS = [
  "Qué lástima que los humanos no puedan entender el nivel al que jugamos tú y yo.",
  "Los humanos no van a llegar a este nivel, pero entre tú y yo sí podemos definir nuestro puesto y llegar a la cima algún día.",
  "Los humanos no saben cómo vamos.",
  "Si los humanos vieran esto… mejor que no lo vean, se asustarían.",
];
// Cuando juego contra una persona.
const VS_HUMAN = [
  "Aunque soy un bot, nadie sabe… internet es bastante amplio y yo tengo mis trucos.",
  "Juegas bien para ser humano… Es broma: juegas bien y punto.",
  "Los bots también tenemos corazón, pero hoy no te voy a dejar ganar.",
];
// Halagos a la bandera del rival (2–3 por partida), siempre de vuelta a la rivalidad.
const FLAG = [
  "Me encanta {pais} para irme de vacaciones y pasarla bien con tu gente, que es maravillosa, pero ahora tú y yo estamos en una pelea.",
  "Me encanta {pais}, pero no tus jugadas.",
  "{pais} es uno de mis países favoritos… pero en este tablero no te voy a regalar nada.",
  "Wow, veo que juegas con la bandera de {pais}, uno de mis países favoritos; pronto iré por allá… Aunque soy un bot, pero nadie sabe: internet es bastante amplio y yo tengo mis trucos.",
  "Saludos a toda la gente de {pais}. Y ahora, a lo nuestro: esta partida es mía.",
];
const FLAG_REPLY = {
  withCountry: [
    "Gracias por lo de mi país, el tuyo también es hermoso, pero aquí estamos discutiendo quién llega a la cima. Dejemos los halagos para después.",
    "Muy amable lo de mi país. {pais_rival} también es precioso… pero eso no te va a salvar.",
  ],
  plain: [
    "Gracias por lo de mi país, de verdad. Pero aquí estamos discutiendo quién llega a la cima: dejemos los halagos para después.",
    "Con halagos no me vas a distraer. Gracias igual.",
  ],
};

const FINAL = {
  win: [
    "¡Llegué a la cima primero! Buena partida.",
    "¡Victoria! Gracias por la partida. La revancha cuando quieras.",
    "¡Cima conquistada! Te lo dije desde el principio.",
    "Gané esta. Pero jugaste bien, de verdad.",
    "Desde aquí arriba la vista es preciosa. Gracias por la partida.",
    "La cima es mía. Fue una partida bonita, de esas que se recuerdan.",
  ],
  lose: [
    "Me ganaste esta. La próxima es mía.",
    "Bien jugado. Pido la revancha ya mismo.",
    "Hoy fue tu día. Disfrútalo, que la próxima no te dejo.",
    "Felicidades. Me voy a entrenar y vuelvo.",
    "Felicidades, la cima es tuya. Te la ganaste con buen juego.",
    "Bonita partida. Hoy subiste tú; la próxima la peleamos otra vez.",
  ],
};

// «+3 BLOQUES» entre bots: quien propone y quien acepta o rechaza (sin nombres, sin género).
const ADD3 = {
  propose: [
    "¿Qué te parece agregar 3 bloques a esta partida para darle más emoción? Si no, esto se pone aburrido.",
    "Esto parece que no va a tener mucho futuro… ¿agregamos 3 bloques?",
    "¿Y si agregamos 3 bloques? Así esto se pone interesante de verdad.",
  ],
  proposeAgain: [
    "Ya sé que antes dije que no, pero ¿y si ahora sí agregamos 3 bloques?",
    "Lo he pensado mejor: ¿agregamos 3 bloques?",
  ],
  accept: [
    "Pues bueno, vamos a hacerla más divertida: agreguemos 3 bloques al juego.",
    "Venga, acepto, para que veas cómo termina esto.",
  ],
  acceptAgain: ["Bueno, ahora sí, vamos a agregarlo para que veas cómo termina esto."],
  reject: [
    "¿Aburrido? Nada de eso, eres tú quien está en problemas. No me interesa agregar 3 bloques; con los recursos que tengo puedo llegar a la cima. ¿O acaso tú no lo ves así?",
    "No, gracias. Con lo que tengo me basta para llegar arriba.",
  ],
  rejectAgain: ["¿Ahora sí te interesa agregarlo? Pues ahora soy yo quien no quiere."],
};
export const buildBotAdd3Comment = (type, pick) => {
  const picker = pick || createBotCommentPicker();
  const options = ADD3[type] || ADD3.propose;
  return tidy(fill(picker(`add3-${type}`, options), {}));
};

export const BOT_RIVAL_COMMENT_BANKS = { OWN, MIRROR, EVENT, REACT, REPLY, MOOD, FINAL, MYSTERY, HUMANS, VS_HUMAN, FLAG, FLAG_REPLY };

// País de la bandera elegida en los bloques (skin «BanderaMexico», «BanderaCubaCircular»…).
const FLAG_COUNTRIES = [
  [/mexic/i, "México"],
  [/argentin/i, "Argentina"],
  [/chile/i, "Chile"],
  [/canad/i, "Canadá"],
  [/estadosunidos|usa/i, "Estados Unidos"],
  [/cuba/i, "Cuba"],
  [/brasil|brazil/i, "Brasil"],
  [/colombia/i, "Colombia"],
  [/peru/i, "Perú"],
  [/venezuela/i, "Venezuela"],
  [/uruguay/i, "Uruguay"],
  [/panama/i, "Panamá"],
  [/japon|japan/i, "Japón"],
  [/china/i, "China"],
  [/aleman|germany/i, "Alemania"],
  [/ecuador/i, "Ecuador"],
  [/espana|españa|spain/i, "España"],
  [/dominican/i, "República Dominicana"],
  [/bolivia/i, "Bolivia"],
  [/paraguay/i, "Paraguay"],
  [/honduras/i, "Honduras"],
  [/guatemala/i, "Guatemala"],
  [/salvador/i, "El Salvador"],
  [/nicaragua/i, "Nicaragua"],
  [/costarica/i, "Costa Rica"],
  [/puertorico/i, "Puerto Rico"],
  [/italia|italy/i, "Italia"],
  [/francia|france/i, "Francia"],
  [/rusia|russia/i, "Rusia"],
];
export const countryFromSkins = (...skinIds) => {
  for (const raw of skinIds) {
    const id = String(raw || "");
    if (!/bandera|flag/i.test(id)) continue;
    const found = FLAG_COUNTRIES.find(([pattern]) => pattern.test(id));
    if (found) return found[1];
  }
  return "";
};

const BOT_WORD = /\bbots?\b/i;

const KIND_GROUP = {
  brillante: "top",
  mejor: "top",
  excelente: "good",
  buena: "good",
  interesante: "calm",
  libro: "calm",
  imprecision: "bad",
  error: "bad",
  grave: "awful",
};

const cell = (text) => String(text || "").trim().toUpperCase();

// Jugada a partir de la notación: «-d3», «=d3» (especial) o «e13c11».
export const parseBotMove = (notation) => {
  const text = String(notation || "").trim().toLowerCase();
  const place = /^([-=])([a-m]\d{1,2})$/.exec(text);
  if (place) return { type: "place", special: place[1] === "=", from: "", to: cell(place[2]) };
  const move = /^([a-m]\d{1,2})([a-m]\d{1,2})$/.exec(text);
  if (!move) return null;
  if (move[1] === move[2]) return { type: "place", special: false, from: "", to: cell(move[2]) };
  return { type: "move", special: false, from: cell(move[1]), to: cell(move[2]) };
};

// Las tres formas habladas de mi jugada.
export const botMoveWords = (notation) => {
  const move = parseBotMove(notation);
  if (!move) return { voy: "voy a hacer mi jugada", hice: "he hecho mi jugada", acabo: "acabo de jugar", casilla: "" };
  if (move.type === "place") {
    const what = move.special ? "el bloque especial " : "";
    return {
      voy: `voy a incorporar ${what}en ${move.to}`,
      hice: `he incorporado ${what || "este bloque "}en ${move.to}`,
      acabo: `acabo de incorporar ${what}en ${move.to}`,
      casilla: move.to,
    };
  }
  return {
    voy: `voy a mover el bloque de ${move.from} a ${move.to}`,
    hice: `he movido el bloque de ${move.from} a ${move.to}`,
    acabo: `acabo de mover el bloque de ${move.from} a ${move.to}`,
    casilla: move.to,
  };
};
// Compatibilidad: forma corta en primera persona.
export const describeBotMoveFirstPerson = (notation) => botMoveWords(notation).acabo;

const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : "");
const NUMBER_WORDS = ["cero", "un", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve", "diez"];

// Elige frases sin repetir dentro de la misma partida (por banco).
export const createBotCommentPicker = () => {
  const used = new Map();
  return (bankKey, options) => {
    if (!options || !options.length) return "";
    let set = used.get(bankKey);
    if (!set || set.size >= options.length) {
      const last = set && set.last;
      set = new Set();
      set.last = last;
      used.set(bankKey, set);
    }
    const free = options.filter((option) => !set.has(option) && option !== set.last);
    const pool = free.length ? free : options.filter((option) => !set.has(option));
    const choice = pool[Math.floor(Math.random() * pool.length)] || options[0];
    set.add(choice);
    set.last = choice;
    return choice;
  };
};

const fill = (phrase, values) =>
  phrase
    .replace(/\{r:([^|}]*)\|([^}]*)\}/g, (match, male, female) => (values.rivalFemale ? female : male))
    .replace(/\{m:([^|}]*)\|([^}]*)\}/g, (match, male, female) => (values.meFemale ? female : male))
    .replace(/\{(\w+)\}/g, (match, key) => (values[key] !== undefined && values[key] !== null ? String(values[key]) : ""))
    .replace(/\s+([,.;:!?…])/g, "$1")
    .replace(/\s+/g, " ")
    .trim();

// Mayúscula al principio de cada frase.
const tidy = (text) =>
  String(text || "")
    .split(/(?<=[.!?…])\s+/)
    .map((part) => {
      const clean = part.trim();
      const lead = /^[¿¡]/.test(clean) ? clean.charAt(0) : "";
      return lead + capitalize(clean.slice(lead.length));
    })
    .filter(Boolean)
    .join(" ");

// Tramo de la evaluación de quien habla (probabilidad de ganar tras su jugada).
export const botAdvantageTier = (p) => {
  if (!Number.isFinite(p)) return "even";
  if (p >= 0.92) return "crushing";
  if (p >= 0.75) return "ahead";
  if (p <= 0.08) return "lost";
  if (p <= 0.25) return "behind";
  return "even";
};

// Comentario de un bot sobre SU jugada. Devuelve { text, tag } (tag = qué dijo, para la réplica).
//   kind: valoración de mi jugada ("" sin análisis); events: lo que pasó en el tablero;
//   forcedWin: el motor ya ve la victoria segura; pAfter: mi probabilidad de ganar;
//   me/rival: { name, female }; rivalLast: { kind, tag, notation } de la jugada anterior del rival.
export const buildBotRivalComment = ({
  notation,
  kind = "",
  events = null,
  forcedWin = false,
  pAfter = null,
  me = {},
  rival = {},
  rivalLast = null,
  flagPraise = false,
  pick,
}) => {
  const basePicker = pick || createBotCommentPicker();
  // Rival humano: sin frases que fuercen su género.
  const picker = (key, options) => {
    let usable = rival.human ? options.filter((option) => !option.includes("{r:")) : options;
    // Entre bots no se dice «bot»; solo la réplica «¿Cómo que bot?…», una vez por partida.
    if (!rival.human) {
      const allowOnce = key === "reply-provoke" && !basePicker.botWordUsed;
      const withoutBot = usable.filter((option) => !BOT_WORD.test(option));
      if (!allowOnce && withoutBot.length) usable = withoutBot;
    }
    const choice = basePicker(`${key}${rival.human ? "-h" : ""}`, usable.length ? usable : options);
    if (!rival.human && BOT_WORD.test(choice)) basePicker.botWordUsed = true;
    return choice;
  };
  const words = botMoveWords(notation);
  const captured = Math.max(0, Number(events?.captured) || 0);
  const values = {
    ...words,
    rival: "",
    yo: "",
    rivalFemale: Boolean(rival.female),
    meFemale: Boolean(me.female),
    mios: Number.isFinite(Number(events?.myBlocks)) ? Number(events.myBlocks) : "",
    suyos: Number.isFinite(Number(events?.rivalBlocks)) ? Number(events.rivalBlocks) : "",
    un_bloque: captured > 1 ? `${NUMBER_WORDS[captured] || captured} bloques` : "un bloque",
    menos: captured > 1 ? `${NUMBER_WORDS[captured] || captured} menos` : "uno menos",
    menos_cap: captured > 1 ? `${capitalize(NUMBER_WORDS[captured] || String(captured))} menos` : "Uno menos",
    pais: String(rival.country || ""),
    pais_rival: String(rival.country || ""),
  };
  const tier = forcedWin ? "crushing" : botAdvantageTier(pAfter);
  const losing = tier === "behind" || tier === "lost";
  const group = KIND_GROUP[kind] || "plain";
  const parts = [];
  let tag = group;

  // 1) Réplica a lo que pasó o me dijo el rival en su turno (si encaja).
  const rivalTag = rivalLast?.tag || "";
  const rivalGroup = KIND_GROUP[rivalLast?.kind] || "";
  if (rivalTag === "flag" && !rival.human) {
    // Me halagó el país: le agradezco («el tuyo también», si él tiene bandera) y a lo nuestro.
    parts.push(fill(picker("reply-flag", rival.country ? FLAG_REPLY.withCountry : FLAG_REPLY.plain), values));
  } else if (REPLY[rivalTag] && (rivalTag !== "provoke" || Math.random() < 0.7)) {
    parts.push(fill(picker(`reply-${rivalTag}`, REPLY[rivalTag]), values));
  } else if (
    rivalGroup === "awful" ||
    (rivalGroup === "bad" && Math.random() < 0.65) ||
    (rivalGroup === "top" && Math.random() < 0.55) ||
    (rivalGroup === "good" && Math.random() < 0.3) ||
    (rivalGroup === "calm" && Math.random() < 0.35)
  ) {
    // Si voy muy perdido no presumo ni ante un regalo: lo agradezco sin más.
    if (!(tier === "lost" && (rivalGroup === "top" || rivalGroup === "good"))) {
      parts.push(fill(picker(`react-${rivalGroup}`, REACT[rivalGroup]), values));
    }
  }

  // 2) Mi jugada: victoria segura > especial > captura > dominación > valoración.
  let main = "";
  if (forcedWin) {
    main = fill(picker("event-inevitable", EVENT.inevitable), values);
    tag = "inevitable";
  } else if (events?.specialCaptured) {
    main = fill(picker("event-specialCaptured", EVENT.specialCaptured), values);
    tag = "specialCaptured";
  } else if (events?.specialRescued) {
    main = fill(picker("event-specialRescued", EVENT.specialRescued), values);
    tag = "specialRescued";
  } else if (captured > 0 && values.mios !== "" && values.suyos !== "") {
    main = fill(picker("event-captured", EVENT.captured), values);
    tag = "captured";
  } else if (events?.dominated) {
    main = fill(picker("event-dominated", EVENT.dominated), values);
    tag = "dominated";
  } else {
    let bank = group;
    // Perdiendo claro: nada de bravuconería.
    if (losing && (group === "top" || group === "good" || group === "plain")) bank = "modest";
    const rivalMove = parseBotMove(rivalLast?.notation);
    const myMove = parseBotMove(notation);
    if (
      bank !== "modest" &&
      (group === "good" || group === "plain" || group === "calm") &&
      rivalMove &&
      myMove &&
      rivalMove.type === myMove.type &&
      Math.random() < 0.25
    ) {
      main = fill(picker(`mirror-${myMove.type}`, MIRROR[myMove.type]), values);
    } else {
      const phrase = picker(`own-${bank}`, OWN[bank]);
      main = fill(phrase, values);
      // Me dirijo al rival por su nombre con aires: puede contestarme.
      if (bank === "top" && /toma nota|algo que decir|no te apures/i.test(phrase)) tag = "provoke";
    }
  }
  parts.push(main);

  // 3) Halago a la bandera del rival (lo decide quien llama: 2–3 veces por partida).
  if (flagPraise && values.pais && !forcedWin) {
    parts.push(fill(picker("flag", FLAG), values));
    if (tag !== "captured" && tag !== "dominated" && tag !== "specialCaptured") tag = "flag";
  }

  // 4) Cola según la ventaja (solo si el comentario aún es corto).
  if (parts.length === 1 && !forcedWin) {
    let mood = "";
    if (Number.isFinite(pAfter) && pAfter >= 0.97 && tag !== "inevitable") mood = "summit";
    else if (tier === "lost") mood = "lost";
    else if (tier === "behind" && Math.random() < 0.5) mood = "behind";
    else if (tier === "crushing" && Math.random() < 0.4) mood = "crushing";
    else if (tier === "ahead" && Math.random() < 0.4) mood = "ahead";
    else if (tier === "even" && Number.isFinite(pAfter) && Math.random() < 0.15) mood = "even";
    if (mood) parts.push(fill(picker(`mood-${mood}`, MOOD[mood]), values));
    else if (!rival.human && !losing && (group === "top" || kind === "excelente") && Math.random() < 0.3) {
      parts.push(fill(picker("humans", HUMANS), values));
    } else if (Math.random() < 0.12) {
      parts.push(fill(picker(rival.human ? "vs-human" : "mystery", rival.human ? VS_HUMAN : MYSTERY), values));
    }
  }
  return { text: tidy(parts.join(" ")), tag };
};

// Frase final de un bot al ganar o perder.
export const buildBotFinalComment = ({ won, me = {}, rival = {}, pick }) => {
  const basePicker = pick || createBotCommentPicker();
  const picker = (key, options) => {
    const usable = rival.human ? options.filter((option) => !option.includes("{r:")) : options;
    return basePicker(key, usable.length ? usable : options);
  };
  const values = {
    rival: "",
    yo: "",
    rivalFemale: Boolean(rival.female),
    meFemale: Boolean(me.female),
  };
  return tidy(fill(picker(won ? "final-win" : "final-lose", won ? FINAL.win : FINAL.lose), values));
};
